import React from 'react';
import { getServicesManager } from '../../services';
import { AIPromptTemplate } from './AIPromptTemplate';
import { emailExamples } from './promptExamples';

export function CustomEmails() {
  const services = getServicesManager();

  return (
    <AIPromptTemplate
      title="Email Prompt"
      description="Define how AI generates follow-up emails. The transcript and metadata will be automatically appended."
      placeholder="Enter your custom email prompt here..."
      testResultLabel="Email"
      examples={emailExamples}
      getPrompt={() => services.getAIEmailFormat()}
      savePrompt={(prompt) => services.putAIEmailFormat(prompt)}
      testPrompt={(sessionId, prompt) => services.testGenerateAIEmail(sessionId, prompt)}
      extractTestResult={(result) => result?.email || null}
      confirmSaveMessage="This will update the AI email generation for all team members."
      confirmDeleteMessage="This will remove the custom email format for all team members."
    />
  );
}
